import { defineNuxtPlugin, useRuntimeConfig } from '#app';
import { useMainStore } from '../stores/mainStore.js';
import { useHead } from '#imports';

export default defineNuxtPlugin(() => {
  if (!useRuntimeConfig().public.GTAG_ID) {
    return;
  }

  useHead({
    script: [
      {
        src: `https://www.googletagmanager.com/gtag/js?id=${useRuntimeConfig().public.GTAG_ID}`,
        async: true,
      },
    ],
  });

  const mainStore = useMainStore();
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;

  gtag('js', new Date());

  gtag('config', useRuntimeConfig().public.GTAG_ID, {
    parent_org: mainStore.parentOrgId,
    secondary_org: mainStore.secondaryOrgId,
    cookie_flags: 'SameSite=Lax;Secure',
  });
});
